import { render, staticRenderFns } from "./CreateContactPad.vue?vue&type=template&id=062bed8a&scoped=true"
import script from "./CreateContactPad.vue?vue&type=script&lang=js"
export * from "./CreateContactPad.vue?vue&type=script&lang=js"
import style0 from "./CreateContactPad.vue?vue&type=style&index=0&id=062bed8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062bed8a",
  null
  
)

export default component.exports